import { render, staticRenderFns } from "./CollarSizeSelect.vue?vue&type=template&id=6b7f9ffc&scoped=true&"
import script from "./CollarSizeSelect.vue?vue&type=script&lang=js&"
export * from "./CollarSizeSelect.vue?vue&type=script&lang=js&"
import style0 from "./CollarSizeSelect.vue?vue&type=style&index=0&id=6b7f9ffc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7f9ffc",
  null
  
)

export default component.exports